import Vue from 'vue'

const mutations = {
  ADD_SUCURSAL(state, sucursal) {
    Vue.set(state.newItem, sucursal, {})
  },

  /**
   * @param {*} state
   * @param { sucursal: sucursal, codigo_comex: p.codigo_comex } data
   */
  ADD_PRODUCTO(state, data) {
    Vue.set(state.newItem[data.sucursal], data.codigo_comex, [])
  },

  /**
   * @param {*} state
   * @param { sucursal: sucursal, partida: p } data
   */
  ADD_PARTIDA(state, data) {
    state.newItem[data.sucursal][data.partida.codigo_comex].push(data.partida)
  },
}

export { mutations }
